import styled from '@emotion/styled';
import React from 'react';
import Button from '@mui/material/Button';
import mainContext from '../../contexts/mainContext';
import RegisterForm from './RegisterForm';
import { getSubAdminsListing } from '../../Controllers/RoleManagement';
import LoopIcon from '@mui/icons-material/Loop';
import Drawer from '@mui/material/Drawer';
import SubAdminProfile from '../OffCanvas/Profile/SubAdminProfile';
import { __constants, __snackBarText, __snackBarSeverity } from '../../constants';
import moment from 'moment';
const anchor = "right"; //DIRECTION FRO WHERE DRAWER WILL OPEN

const SubAdmin = () => {
  const { setSnackBar, setProfileNavTitle,setPageload } = React.useContext(mainContext);
  const [canvasState, setCanvasState] = React.useState({
    open: false,
    userId: ""
  });
  const [open, setOpen] = React.useState(false);
  const [subAdmins, setSubAdmins] = React.useState([]);

  const callSnackBar = (msg, type) => {
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type]
    });
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getSubAdmins = async () => {
    setPageload(true)
    const res = await getSubAdminsListing();
    setPageload(false)
    if (res && res.status === 500) {
      return callSnackBar(__snackBarText.internalServerError, "error")
    }
    if (res.data.status !== 200) {
      return callSnackBar(res.data.errors[0].message, "error");
    }
    setSubAdmins(res.data.data.users);
  }

  const handleView = (e, index) => {
    setCanvasState({
      open: true,
      user: e,
      index: index
    })
  }

  const handleCanvasClose = () => {
    setCanvasState({
      open: false,
      user: "",
      index: 0
    })
  }

  React.useEffect(() => {
    getSubAdmins();
    setProfileNavTitle("Managers");
    // eslint-disable-next-line
  }, [])

  const handleAdd = (data) => {
    let temp = [...subAdmins]
    temp.unshift(data)
    setSubAdmins(temp)
  }

  return (
    <>
      <Drawer
        anchor={anchor}
        open={canvasState.open}
        onClose={() => { handleCanvasClose() }}
      >
        <SubAdminProfile
          canvasState={canvasState}
          setCanvasState={setCanvasState}
          cb={(data, index) => {
            let temp = [...subAdmins];
            temp[index] = data;
            setSubAdmins(temp);
            setCanvasState({ open: false, user: {} })
          }} />
      </Drawer>
      {
        open ?
          <RegisterForm open={open} handleClose={handleClose} onAdd={handleAdd} />
          :
          <></>
      }
      <Conatiner className='scrollbar'>
        <Header>
          <Button variant="contained" size='small' onClick={handleClickOpen}>Add new</Button>
        </Header>
        <Body>

          <List className='list_header'>
            <div>Status</div>
            <div>Name</div>
            <div>Email</div>
            <div>Mobile</div>
            <div>Role</div>
            <div>Registered on</div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}><LoopIcon onClick={getSubAdmins} className="pointer" /></div>
          </List>

          {
            subAdmins.map((e, index) => {
              return (
                <List key={e._id}>
                   <div>
                      <div className={`list_card_status ${e.status === "Active" ? "status_active" : "status_inactive"}`}>{e.status}</div>
                  </div>
                  <div>{e.firstName} {e.lastName}</div>
                  <div>{e.email}</div>
                  <div>{e.mobileNo}</div>
                  <div>{e.role}</div>
                  <div>{moment(e.createdAt).format("MMM DD, YYYY")}</div>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button className="list_card_view_btn" onClick={() => { handleView(e, index) }}>View</button>
                  </div>
                </List>
              )
            })
          }
        </Body>
      </Conatiner>
    </>
  )
}

const Conatiner = styled("div")`
  overflow-x: auto;
  margin-bottom: 1rem;
    .input{
      margin-bottom: 5%;
      width: 100%;
    }
    button{
      text-transform: none;
    }
`;

const Header = styled("div")`
  button{
    border-radius: 5px;
  }
`;
const Body = styled("div")`
  margin-top: 1rem;
  height: 80vh;
  min-width: 1000px;
`;

const List = styled("div")`
  font-size: 80%;
  margin: 1rem 0;
  display: grid;
  grid-template-columns: 1.5fr 3fr 5fr 2fr 1.5fr 2fr 1fr;
  align-items: center;
  column-gap: 0.5rem;
`;

export default SubAdmin